import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from '@tanstack/react-query';
import { ReadLead, UpdateLead } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface PatchLeadParams {
  id: string;
  data: Partial<UpdateLead>;
}

export const patchLead = async (params: PatchLeadParams): Promise<ReadLead> => {
  return await tinctApi.leads.patchLead(params.id, params.data);
};

export const usePatchLead = (
  options?: Omit<
    UseMutationOptions<ReadLead, ApiError, PatchLeadParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchLead,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['leads'] });
      queryClient.invalidateQueries({ queryKey: ['lead', args[1].id] });
      queryClient.invalidateQueries({ queryKey: ['audiences'] });
      if (args[0].organization) {
        queryClient.invalidateQueries({ queryKey: ['organization', args[0].organization.id] });
      }
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
